import * as Scrivito from "scrivito"
import { NotificationType } from "shared/context/NotificationContext"
import { EDITOR_ICONS } from "shared/ui/icon/EditorIcons"

export const LinkListIconLinkWidget = Scrivito.provideWidgetClass(
  "LinkListIconLinkWidget",
  {
    attributes: {
      link: "link",
      icon: ["enum", { values: EDITOR_ICONS }],
      hideTooltip: "boolean",
      notificationType: [
        "enum",
        { values: ["none", ...Object.values(NotificationType)] }
      ]
    }
  }
)

export type LinkListIconLinkWidgetInstance = InstanceType<
  typeof LinkListIconLinkWidget
>
